import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { GlobalComponent } from './global/global.component';
import {  HttpHandler, HttpRequest, HttpEvent, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
@Injectable()
export class AuthService {
  url: string = ""
  constructor(private router: Router, public global: GlobalComponent, private http: HttpClient, private configurationService: ConfigurationService) {
    let configuration = configurationService.getConfiguration();
    this.url = configuration.baseUrl;
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // for agency login & client onboarding & employee onboarding//
    if (this.global.agencyCode != "SUPERADMIN") {
      request = request.clone({
        url: this.url + request.url,
        setHeaders: {
          'Authorization': `Bearer ` + this.global.authtoken,
        },
        withCredentials: true
      });
    }
    // for superadmin
    else if (this.global.agencyCode != null && this.global.agencyCode != undefined) {
      if (this.global.agencyCode == "SUPERADMIN") {
        if (this.global.globalHeadAgencyId == null || this.global.globalHeadAgencyId == undefined || this.global.globalHeadAgencyId == "") {
          this.global.globalHeadAgencyId = "00000000-0000-0000-0000-000000000000";
        }
        request = request.clone({
          url: this.url + request.url,
          setHeaders: {
            'Authorization': `Bearer ` + this.global.authtoken,
            'AgencyId': this.global.globalHeadAgencyId
          },
          withCredentials: true
        });

      }
    }
    return next.handle(request);
  }
}